export const MOBILE_MEDIA_QUERY = '(max-width: 539px)';
